import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';

export const BulkDiscountContainer = styled.div`
  padding: ${Spacing.SINGLE} 0;
`;

export const FreeDeliveryContainer = styled.div`
  max-width: 600px;
`;
